// extracted by mini-css-extract-plugin
export var container = "_5d-0";
export var infoButton = "_5d-1";
export var label = "_5d-3";
export var labelExpanded = "_5d-4";
export var price = "_5d-5";
export var priceExpanded = "_5d-6";
export var title = "_5d-2";